'use client';

import { c as _c } from "react/compiler-runtime";
import './help-me-choose.scss';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { StepperTabbed } from '@sola/ark-core/molecules/stepper-tabbed/stepper-tabbed.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { HelpMeChooseResultSkeleton } from '../../organisms/help-me-choose/result/result-skeleton.tsx';
import { HelpMeChooseResult } from '../../organisms/help-me-choose/result/result.tsx';
import { HelpMeChooseAge } from './answers/help-me-choose-age.tsx';
import { HelpMeChooseCause } from './answers/help-me-choose-cause.tsx';
import { HelpMeChooseGender } from './answers/help-me-choose-gender.tsx';
import { HelpMeChooseRegion } from './answers/help-me-choose-region.tsx';
import { HelpMeChooseFooter } from './help-me-choose-footer.tsx';
import { HelpMeChoosePage } from './help-me-choose-page.tsx';
import { useHelpMeChoose } from './help-me-choose.logic.ts';
export const HelpMeChooseInner: React.FC = () => {
  const $ = _c(98);
  const {
    t
  } = useTranslation("help-me");
  const {
    isSkipped,
    resultsStatus,
    childDetails,
    currentChild,
    backwardsClick,
    forwardClick,
    forwardDisabled,
    isLastStep,
    isSecondToLastStep
  } = useHelpMeChoose();
  let t0;
  if ($[0] !== isLastStep || $[1] !== t) {
    t0 = isLastStep ? t("help-me:pagination.startOver") : t("help-me:pagination.back");
    $[0] = isLastStep;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const backwardsLabel = t0;
  let t1;
  bb0: {
    if (isLastStep) {
      let t2;
      if ($[3] !== t) {
        t2 = t("help-me:pagination.refreshResults");
        $[3] = t;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      t1 = t2;
      break bb0;
    }
    if (isSecondToLastStep) {
      let t2;
      if ($[5] !== isSkipped || $[6] !== t) {
        t2 = isSkipped ? t("help-me:pagination.skipAndView") : t("help-me:pagination.meetMyMatch");
        $[5] = isSkipped;
        $[6] = t;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[8] !== isSkipped || $[9] !== t) {
      t2 = isSkipped ? t("help-me:pagination.skip") : t("help-me:pagination.next");
      $[8] = isSkipped;
      $[9] = t;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = t2;
  }
  const forwardLabel = t1;
  const forwardVariant = isSkipped ? "secondary" : "primary";
  let t2;
  if ($[11] !== isLastStep || $[12] !== isSkipped) {
    t2 = isSkipped ? undefined : <ArkIcon iconName={isLastStep ? "refresh-ccw-05" : "arrow-narrow-right"} />;
    $[11] = isLastStep;
    $[12] = isSkipped;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const forwardIcon = t2;
  let t3;
  if ($[14] !== t) {
    t3 = t("help-me:pagination.cause");
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t) {
    t4 = t("help-me:questions.how");
    $[16] = t;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t) {
    t5 = t("help-me:questions.selectHow");
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HelpMeChooseCause />;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t5) {
    t7 = <HelpMeChoosePage header={t4} description={t5} answers={t6} />;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t3 || $[25] !== t7) {
    t8 = {
      title: t3,
      body: t7
    };
    $[24] = t3;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t) {
    t9 = t("help-me:pagination.gender");
    $[27] = t;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t("help-me:questions.gender");
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t) {
    t11 = t("help-me:questions.selectGender");
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <HelpMeChooseGender />;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11) {
    t13 = <HelpMeChoosePage header={t10} description={t11} answers={t12} />;
    $[34] = t10;
    $[35] = t11;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== t9) {
    t14 = {
      title: t9,
      body: t13
    };
    $[37] = t13;
    $[38] = t9;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t) {
    t15 = t("help-me:pagination.age");
    $[40] = t;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t) {
    t16 = t("help-me:questions.age");
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t) {
    t17 = t("help-me:questions.selectAge");
    $[44] = t;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <HelpMeChooseAge />;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t16 || $[48] !== t17) {
    t19 = <HelpMeChoosePage header={t16} description={t17} answers={t18} />;
    $[47] = t16;
    $[48] = t17;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t15 || $[51] !== t19) {
    t20 = {
      title: t15,
      body: t19
    };
    $[50] = t15;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t) {
    t21 = t("help-me:pagination.location");
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t) {
    t22 = t("help-me:questions.region");
    $[55] = t;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t) {
    t23 = t("help-me:questions.selectRegion");
    $[57] = t;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <HelpMeChooseRegion />;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t22 || $[61] !== t23) {
    t25 = <HelpMeChoosePage header={t22} description={t23} answers={t24} />;
    $[60] = t22;
    $[61] = t23;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t21 || $[64] !== t25) {
    t26 = {
      title: t21,
      body: t25
    };
    $[63] = t21;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t) {
    t27 = t("help-me:pagination.yourMatch");
    $[66] = t;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== childDetails || $[69] !== currentChild || $[70] !== resultsStatus || $[71] !== t) {
    t28 = (resultsStatus === "matched" || resultsStatus === "fallback") && currentChild && <><div className="mb-comfy-lg"><h1 className="heading-sm heading-neutral-amplified">{resultsStatus === "fallback" ? t("help-me:result.headingB") : t("help-me:result.heading")}</h1><p className="label-moderate label-lg mt-snug-lg">{resultsStatus === "fallback" ? t("help-me:result.noMatch") : t("help-me:result.subheading", {
            childName: currentChild.name.preferred,
            interpolation: {
              escapeValue: false
            }
          })}</p></div><HelpMeChooseResult childDetails={childDetails} childAvailability={currentChild} /></>;
    $[68] = childDetails;
    $[69] = currentChild;
    $[70] = resultsStatus;
    $[71] = t;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== resultsStatus) {
    t29 = (resultsStatus === "idle" || resultsStatus === "loading" || resultsStatus === "error") && <HelpMeChooseResultSkeleton />;
    $[73] = resultsStatus;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t28 || $[76] !== t29) {
    t30 = <div className="HelpMeChoose__page">{t28}{t29}</div>;
    $[75] = t28;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== t27 || $[79] !== t30) {
    t31 = {
      title: t27,
      body: t30
    };
    $[78] = t27;
    $[79] = t30;
    $[80] = t31;
  } else {
    t31 = $[80];
  }
  let t32;
  if ($[81] !== t14 || $[82] !== t20 || $[83] !== t26 || $[84] !== t31 || $[85] !== t8) {
    t32 = <div><StepperTabbed items={[t8, t14, t20, t26, t31]} /></div>;
    $[81] = t14;
    $[82] = t20;
    $[83] = t26;
    $[84] = t31;
    $[85] = t8;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] !== backwardsClick || $[88] !== backwardsLabel || $[89] !== forwardClick || $[90] !== forwardDisabled || $[91] !== forwardIcon || $[92] !== forwardLabel || $[93] !== forwardVariant) {
    t33 = <HelpMeChooseFooter backwardsLabel={backwardsLabel} backwardsClick={backwardsClick} forwardLabel={forwardLabel} forwardVariant={forwardVariant} forwardIcon={forwardIcon} forwardClick={forwardClick} forwardDisabled={forwardDisabled} />;
    $[87] = backwardsClick;
    $[88] = backwardsLabel;
    $[89] = forwardClick;
    $[90] = forwardDisabled;
    $[91] = forwardIcon;
    $[92] = forwardLabel;
    $[93] = forwardVariant;
    $[94] = t33;
  } else {
    t33 = $[94];
  }
  let t34;
  if ($[95] !== t32 || $[96] !== t33) {
    t34 = <section><div className="HelpMeChoose HideBreadcrumbs HideFooter">{t32}{t33}</div></section>;
    $[95] = t32;
    $[96] = t33;
    $[97] = t34;
  } else {
    t34 = $[97];
  }
  return t34;
};
export const HelpMeChoose: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense><HelpMeChooseInner /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};